export function LogoMark({ className = "h-9 w-auto" }) {
  return (
    <img
      src="/bt-logo.png"
      alt="BT Design logo"
      className={`${className} object-contain`}
    />
  );
}

export default function Logo({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="nav-logo"
      aria-label="BT Design, back to top"
      className="group flex items-center gap-3"
    >
      <span className="transition-transform duration-500 group-hover:-translate-y-0.5">
        <LogoMark />
      </span>
      <span className="font-mono text-xs uppercase tracking-[0.28em] text-sub">
        Building Digital Possibilities
      </span>
    </button>
  );
}
